<div class="provision-modal">
    <div class="provision-modal__header">
        <h3>{{ 'gateways_add' | translate }}</h3>
        <button type="button" class="provision-modal__close" (click)="activeModal.dismiss()" [attr.aria-label]="'admin_action_close' | translate">&times;</button>
    </div>

    @if (provisionedCode) {
        <div class="provision-modal__success">
            <p class="message">{{ 'provision_success_message' | translate }}</p>
            <div class="code">{{ provisionedCode }}</div>
            @if (duplicateWarning) {
                <!-- The gateway WAS created; this only says the uid is not unique. -->
                <p class="warning">{{ duplicateWarning }}</p>
            }
            <button type="button" class="provision-modal__submit" (click)="activeModal.close(true)">{{ 'provision_done' | translate }}</button>
        </div>
    } @else {
        <form class="provision-modal__body" (ngSubmit)="submit()">
            <label class="field">
                <span>{{ 'gateways_table_uid' | translate }}</span>
                <input ngbAutofocus type="text" name="uid" [(ngModel)]="uid" autocomplete="off" required />
            </label>

            @if (error) {
                <p class="error">{{ error }}</p>
            }

            <button type="submit" class="provision-modal__submit" [disabled]="submitting || !uid.trim()">
                {{ 'admin_action_save' | translate }}
            </button>
        </form>
    }
</div>
